import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-4">
              <i className="ri-leaf-line mr-1"></i>庭院花园
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专注庭院花园设计与草坪造景，从选种、养护到景观搭配，为您提供一站式的花园绿化解决方案。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { to: '/', label: '首页' },
                { to: '/category/caoping-xuanzhong', label: '草坪选种' },
                { to: '/category/huayuan-sheji', label: '花园设计' },
                { to: '/category/jingguan-dapei', label: '景观搭配' },
              ].map((link) => (
                <Link key={link.to} to={link.to} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-3">更多内容</h4>
            <div className="flex flex-col gap-2">
              {[
                { to: '/category/caoping-yanghu', label: '草坪养护' },
                { to: '/category/tingyuan-lvhua', label: '庭院绿化' },
                { to: '/category/huwai-kongjian', label: '户外空间' },
                { to: '/about', label: '关于我们' },
              ].map((link) => (
                <Link key={link.to} to={link.to} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-3">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <span><i className="ri-mail-line mr-1"></i> contact@tingyuanhuayuan.cn</span>
              <span><i className="ri-phone-line mr-1"></i> 400-888-9999</span>
              <span><i className="ri-map-pin-line mr-1"></i> 上海市浦东新区园林路168号</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 庭院花园. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="/privacy" className="hover:text-foreground-600 transition-colors" rel="nofollow">隐私政策</a>
            <a href="/terms" className="hover:text-foreground-600 transition-colors" rel="nofollow">服务条款</a>
            <a href="/sitemap" className="hover:text-foreground-600 transition-colors" rel="nofollow">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}